import React, { useEffect, useState, useCallback } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { FullPageLoading } from 'components'
import { getQueryParamsValue } from 'utils'

import { useLoginHook, useExtenalCompanyHook } from 'hooks'

export const CheckPartner = () => {
    const location = useLocation()
    const { checkAccountService } = useExtenalCompanyHook()
    const { signOut } = useLoginHook()

    const [redirectPath, setRedirectPath] = useState<string | undefined>(undefined)

    const checkAccount = useCallback(async () => {
        const federalTaxID = sessionStorage.getItem('@Livia/federalTaxId')
        if (federalTaxID) {
            const account = await checkAccountService(federalTaxID)
            return account.status
        }
        return undefined
    }, [checkAccountService])

    useEffect(() => {
        const check = async () => {
            const redirectLoginPath: string | undefined = getQueryParamsValue(location, 'redirectAfterLogin') || undefined
            const redirectTo = `?redirectTo=${redirectLoginPath}`

            if (redirectLoginPath) {
                try {
                    const account = await checkAccount()
                    signOut()
                    if (account && ['LOGINFOUNDED', 'LOGINFOUND'].includes(account)) {
                        setRedirectPath(`/login${redirectTo}`)
                    }
                    setRedirectPath(`/cadastrar${redirectTo}`)
                } catch (e) {
                    setRedirectPath(`/login${redirectTo}`)
                }
            }
        }

        check()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <FullPageLoading />
            {redirectPath && <Redirect to={redirectPath} />}
        </>
    )
}
